import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return typeof d === "object" ? d.msg || JSON.stringify(d) : String(d);
};

export const trackEvent = (name, props = {}) => {
  try { api.post("/events", { name, props }); } catch (_) {}
};

// Demo/preview placeholders used only when the real business numbers
// haven't been set in Admin → Settings yet. They render visibly in UI
// with a small DEMO tag so a reviewer can tap through every CTA.
export const DEMO_PHONE = "+910000000000";
export const DEMO_WHATSAPP = "+910000000000";

export const resolveContact = (settings) => {
  const phone = (settings?.phone || "").trim();
  const whatsapp = (settings?.whatsapp_number || "").trim();
  return {
    phone: phone || DEMO_PHONE,
    whatsapp: whatsapp || DEMO_WHATSAPP,
    phoneIsDemo: !phone,
    whatsappIsDemo: !whatsapp,
  };
};
